export { default } from './assignIn.js'



//////////////////
// WEBPACK FOOTER
// ./~/lodash-es/extend.js
// module id = 607
// module chunks = 41